import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { lastValueFrom } from 'rxjs';

// PrimeNg
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

// Services
import { BotoneraApiService } from '../botonera.api.service';
import { IDevolverArchivos, IPaso } from '../botonera.interface';
import { IFormSearchLupa, Item } from '../../general/lupas/interfaces/lupas.interfaces';
import { LupasComponent } from '../../general/lupas/lupas.component';

@Component({
  selector: 'app-modal-devolver-archivo-paso-anterior',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonModule, LupasComponent],
  templateUrl: './modal-devolver-archivo-paso-anterior.component.html',
  styleUrl: './modal-devolver-archivo-paso-anterior.component.scss',
})
export class ModalDevolverArchivoPasoAnteriorComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  apiService = inject(BotoneraApiService);
  fb = inject(FormBuilder);

  form: FormGroup = this.fb.group({});
  request: IDevolverArchivos;

  // lupa
  dataSearchLupaPasoDestino: IFormSearchLupa = {
    idFormulario: 'noFormMotivosAreasAnteriores',
    campo: 'noFormMotivosAreasAnteriores',
    label: 'Paso anterior',
    dependencias: { IdfdArchivo: null, CodigoCuerpo: null },
    required: true,
  };

  constructor() {
    this.request = this.config.data;
    this.buildForm();
    this.setDependenciasLupa();
  }

  async confirmar() {
    // recoge el motivo
    this.request.Motivo = this.form.get('Motivo')?.value;

    // envia la solicitud al API
    const response = await lastValueFrom(this.apiService.PutDevolverDocumento(this.request));

    // cierra el modal retornando la respuesta
    this.ref.close(response);
  }

  cerrarModal() {
    this.ref.close(false);
  }

  // Lupa
  buildForm() {
    this.form = this.fb.group({
      CodigoCuerpo: this.fb.control(null, Validators.required),
      Motivo: this.fb.control(null, Validators.required),
    });
  }

  onPasoSeleccionado(item: Item) {
    const propertiesPasoDestino = (item.Propiedades ?? {}) as IPaso;
    this.request.CodfdCuerpoDestino = Number(propertiesPasoDestino.CodfdCuerpo); 
    this.request.CodfdDocPermitidosDestino = Number(propertiesPasoDestino.CodfdDocPermitidos);
    this.request.CodGlobal = this.request.CodGlobal2;
  }

  setDependenciasLupa() {
    this.dataSearchLupaPasoDestino.dependencias = {
      IdfdArchivo: this.request.IdfdArchivo,
      CodigoCuerpo: this.request.CodfdCuerpo,
    };
  }
}
